import {User} from "@app/core/user/domain/entities/user";
import {Observable} from "rxjs";

export abstract class UserLocal {

    public abstract isLoggedIn$: Observable<boolean>;
    public abstract isGuest$: Observable<boolean>;

    public abstract saveUser(user: User): void;
    public abstract getUser(): User | null;
    public abstract getIfHasVisitedTheLanding(): boolean;
    public abstract setVisitedTheLanding(): void;
    public abstract logout(): void;
}
